import React, { useState } from "react";
import {
  Button,
  Dialog,
  TextField,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Provider from "provider";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectGameId } from "features/gamestate/gameStateSlice";
import logging from "utils/logging";

const log = logging.getLogger("Game Settings");

const StyledButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

const CopyGameButton = () => {
  const gameId = useSelector(selectGameId);
  const navigate = useNavigate();

  const [copying, setCopying] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [newGameName, setNewGameName] = useState("");

  const closeConfirm = () => setConfirmOpen(false);

  const copyGame = async () => {
    setCopying(true);
    setConfirmOpen(false);
    const result = await Provider.copyGame(gameId, newGameName);
    log.debug("copy game result: ", result);

    setCopying(false);
    const newGameId = result.data.gameId;
    // Redirect to the new game
    navigate(`/manage/game/${newGameId}/editor`);
  };

  return (
    <React.Fragment>
      <StyledButton
        size="large"
        variant="contained"
        onClick={() => setConfirmOpen(true)}
        color="primary"
        disabled={copying}
      >
        Copy Game
      </StyledButton>
      <Dialog
        open={confirmOpen}
        onClose={closeConfirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            This will create a complete copy of your game with all the questions and categories, but without any players or game state.
            <br />
            <br />
            The copying process may take a minute to complete. Once finished, you'll be redirected to your new game.
            <br />
            <br />
            What would you like to name your new game?
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="copied-game-name"
            label="New Game Name"
            type="text"
            fullWidth
            onChange={(v) => setNewGameName(v.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={closeConfirm} color="primary">
            Cancel
          </Button>
          <Button onClick={copyGame} color="primary" autoFocus>
            Create a Copy
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default CopyGameButton;
